import { render, staticRenderFns } from "./TestPaperComponent.vue?vue&type=template&id=54171a2e&"
import script from "./TestPaperComponent.vue?vue&type=script&lang=js&"
export * from "./TestPaperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/TestPaperComponent.vue"
export default component.exports